import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import resourcesToBackend from 'i18next-resources-to-backend';

i18next
	.use(initReactI18next)
	.use(resourcesToBackend((language, namespace) =>
		import(`../../locales/${language}/${namespace}.json`)
	))
	.init({
		lng: 'en',
		defaultNS: 'translations',
		ns: [
			'translations'
		],
		saveMissing: true,
		interpolation: {
		  escapeValue: false // react already safes from xss
		},
		react: { useSuspense: false }
	})


export default i18next;
